import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import { BatchHttpLink } from "apollo-link-batch-http";
import { RetryLink } from "apollo-link-retry";
import { createUploadLink } from "apollo-upload-client";
import { extractFiles } from "extract-files";
import { SaleorAPI } from "./api";
import { APIProxy } from "./api/APIProxy";

var uploadAndBatchHTTPLink = function uploadAndBatchHTTPLink(opts) {
  return ApolloLink.split(function (operation) {
    return extractFiles(operation).files.size > 0;
  }, createUploadLink(opts), new BatchHttpLink(opts));
};

var getLink = function getLink(apiUrl, invalidTokenLink, authLink) {
  return ApolloLink.from([invalidTokenLink, authLink, new RetryLink(), uploadAndBatchHTTPLink({
    uri: apiUrl
  })]);
};

export var createSaleorClient = function createSaleorClient(apiUrl, invalidTokenLink, authLink, cache) {
  return new ApolloClient({
    cache: cache,
    link: getLink(apiUrl, invalidTokenLink, authLink)
  });
};
export var SaleorManager =
/*#__PURE__*/
function () {
  function SaleorManager(client, config) {
    var _this = this;

    _classCallCheck(this, SaleorManager);

    this.onSaleorAPIChange = function () {
      if (_this.apiChangeListener) {
        _this.apiChangeListener(_this.api);
      }
    };

    this.apiProxy = new APIProxy(client);
    this.api = new SaleorAPI(client, this.apiProxy, config, this.onSaleorAPIChange);
  }
  /**
   * Use this method to obtain current API and listen to its update on occured changes within it.
   * @param apiChangeListener Function called to get an API and called on every API update.
   */


  _createClass(SaleorManager, [{
    key: "connect",
    value: function connect(apiChangeListener) {
      this.apiChangeListener = apiChangeListener;
      this.apiChangeListener(this.api);
    }
  }]);

  return SaleorManager;
}();